import { useMutation } from '@tanstack/react-query';
import { CreateQuickTaskRequest } from 'compliance-api';
import { FormikErrors, FormikValues } from 'formik';
import { api } from '@/modules/common/api/index.ts';
import {
  CURRENT_USER_TASKS_LIST_BY_LINKED_INCIDENT_QUERY_KEY,
  CURRENT_USER_TASKS_LIST_QUERY_KEY,
} from '@/modules/common/queries/tasks.ts';
import { queryClient } from '@/modules/common/query.ts';
import { withErrorHandling } from '@/modules/common/utils/error-utils.tsx';
import {
  CURRENT_USER_TASKS_ACTIVITY_LOGS_QUERY_KEY,
  CURRENT_USER_UPCOMING_TASKS_CHART_QUERY_KEY,
} from '@/modules/admin-dashboard/queries/tasks.ts';

export const useQuickCreateTaskMutation = (
  setErrors?: (errors: FormikErrors<FormikValues>) => void,
) => {
  return useMutation({
    mutationFn: async (payload: CreateQuickTaskRequest) => {
      const response = await withErrorHandling(
        api.v1.createQuickTaskV1TasksQuickTaskPost(payload),
        {
          loading: 'Creating quick task...',
          success: 'Task created, assigned users notified!',
          setErrors,
        },
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([CURRENT_USER_TASKS_LIST_BY_LINKED_INCIDENT_QUERY_KEY]);
      queryClient.invalidateQueries([CURRENT_USER_TASKS_LIST_QUERY_KEY]);
      queryClient.invalidateQueries([CURRENT_USER_UPCOMING_TASKS_CHART_QUERY_KEY]);
      queryClient.invalidateQueries([CURRENT_USER_TASKS_ACTIVITY_LOGS_QUERY_KEY]);
    },
  });
};
